import { render, staticRenderFns } from "./practicalMarkList.vue?vue&type=template&id=5843cb94&"
import script from "./practicalMarkList.vue?vue&type=script&lang=js&"
export * from "./practicalMarkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports